import { Helmet } from 'react-helmet'
import React, { useState } from 'react'
import RestaurantsPageLayout from '../../../components/restaurants/RestaurantsPageLayout'
import ResactlyCard from '../../../components/ui/ResactlyCard'
import ResactlyTab from '../../../components/ResactlyTab'
import LeaderboardTab from './components/LeaderboardTab'
import PointTransactionTab from './components/PointTransactionTab'

const Leaderboard: React.FC = () => {
  const [changeTab] = useState(0)
  return (
    <>
      <Helmet><title>Resactly | Points & Leaderboard</title></Helmet>
      <RestaurantsPageLayout
        title="Leaderboard"
        body={
          <ResactlyCard sx={{ flex: 1, height: '100%' }}>
            <ResactlyTab
              list={tabList}
              tabComponent={tabComponentList}
              align="start"
              changeTab={changeTab}
            />
          </ResactlyCard>
        }
      />
    </>
  )
}

export default Leaderboard
const tabComponentList = [
  <LeaderboardTab key="leaderboard" />,
  <PointTransactionTab key="point-transaction" />,
]

const tabList = [
  {
    label: 'Leaderboard',
    value: 'leaderboard',
  },
  {
    label: 'Point Transaction ',
    value: 'point-transaction',
  },
]
